var Url =
/** @class */
function () {
  function Url() {}

  Url.composa = function () {
    var _this = this;

    var parts = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      parts[_i] = arguments[_i];
    }

    var url = parts.map(function (part) {
      return _this.treuSep(part);
    }).filter(function (part) {
      return part.trim() !== '';
    }).join('/');
    return url.startsWith('http://') || url.startsWith('https://') ? url : "http://" + url;
  };

  Url.treuSep = function (part) {
    return part ? part.replace(/\/*$/, '').replace(/^\/*/, '') : '';
  };

  return Url;
}();

export default Url;